// ─── Enums ───
/** Supported LLM provider types */
export var LlmProviderType;
(function (LlmProviderType) {
    LlmProviderType["OPENAI"] = "OPENAI";
    LlmProviderType["ANTHROPIC"] = "ANTHROPIC";
    LlmProviderType["CUSTOM"] = "CUSTOM";
})(LlmProviderType || (LlmProviderType = {}));
/** Status of an LLM API call */
export var LlmCallStatus;
(function (LlmCallStatus) {
    LlmCallStatus["PENDING"] = "PENDING";
    LlmCallStatus["SUCCESS"] = "SUCCESS";
    LlmCallStatus["FAILED"] = "FAILED";
    LlmCallStatus["TIMEOUT"] = "TIMEOUT";
})(LlmCallStatus || (LlmCallStatus = {}));
// ─── Model Catalog DTOs ───
/** Source of the model catalog entry */
export var LlmModelSource;
(function (LlmModelSource) {
    LlmModelSource["OPENROUTER"] = "OPENROUTER";
    LlmModelSource["MANUAL"] = "MANUAL";
})(LlmModelSource || (LlmModelSource = {}));
